import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Form, Input, Upload, Icon, Alert } from 'antd'
import { infoRequired, validateCep } from '../../utils/validators'
import { maskCepOnChange as maskCep } from '../../utils/masks'
import 'moment/locale/pt-br'
import { PureComponent } from 'react'
import { ReactComponent as UploadIcon } from '../../images/document-upload.svg'
import axios from 'axios'

const { Dragger } = Upload


const FormEndereco = Form.create({ name: 'form-dados' })(
    ({ form, beforeUpload, onChangeCep, cidade, estado, endereco, bairro, message, onRemove, error, isLoading, handleSubmit, userid, file }) => {
        return (
            <Form layout="vertical" onSubmit={handleSubmit(form, file, 2, userid)}>
                <Col md={12} className='p-0'>
                    <h3 className='mt-0 mb-5 subtitleRegistro text-white text-uppercase' style={{fontFamily: 'Axiforma Black'}}>Endereço</h3>    
                </Col>
                <Col md={12}>
                    {error !== null && <Alert type="error" message={error} className="mb-5" />}
                </Col>
                <Col md={12} className='p-0 pr-2 mb-3'>
                    <Form.Item label="CEP (ao preencher o CEP, as informações do endereço serão atualizadas automaticamente)">
                        {form.getFieldDecorator('cep', {
                            rules: [
                                infoRequired,
                                validateCep()
                            ]
                        })(
                            <Input type="text" placeholder="CEP" onKeyPress={maskCep} onChange={onChangeCep} />
                            
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2 mb-3'>
                    <Form.Item label="Cidade">
                        {form.getFieldDecorator('cidade', {
                            rules: [
                                infoRequired,
                            ], initialValue: cidade
                            })(
                            <Input placeholder="Cidade" />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pl-2 mb-3'>
                    <Form.Item label="Estado">
                        {form.getFieldDecorator('estado', {
                            rules: [
                                infoRequired,
                            ], initialValue: estado
                        })(
                            <Input type="text" placeholder="Estado" />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2 mb-3'>
                    <Form.Item label="Endereço">
                        {form.getFieldDecorator('endereco', {
                            rules: [ infoRequired ], initialValue: endereco
                        })(
                            <Input type="text" placeholder="Endereço" />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2 mb-3'>
                    <Form.Item label="Número">
                        {form.getFieldDecorator('numero', {
                            rules: [ infoRequired ]
                        })(
                            <Input type="text" placeholder="Número" />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2 mb-3'>
                    <Form.Item label="Complemento">
                        {form.getFieldDecorator('complemento', {
                        })(
                            <Input type="text" placeholder="Complemento" />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2 mb-3'>
                    <Form.Item label="Bairro">
                        {form.getFieldDecorator('bairro', {
                            rules: [ infoRequired ], initialValue: bairro
                        })(
                            <Input type="text" placeholder="Bairro" />
                        )}
                    </Form.Item>
                </Col>
                {/* <Col md={12} className="p-0">
                    <Dragger className='uploadCadastro' beforeUpload={beforeUpload} onRemove={onRemove}>
                        <UploadIcon />
                        <p className="text-white mt-3">
                            {file === null ? 'Faça o upload do seu\ncomprovante de residência' : 'Arquivo carregado'}
                        </p>
                    </Dragger>
                    {message !== null && <span className="text-danger mb-3">{message}</span>}
                </Col> */}
                <Col md={12} className="mt-5">
                    <Form.Item>
                        <button className="anchorBtn w-100 buttonRegistro" type='submit'>
                            {isLoading ? <Icon type="loading" /> : "Concluir Inscrição"}
                        </button>
                    </Form.Item>
                </Col>
            </Form>
        )
    }
)

class Form2 extends PureComponent {

// export default class Form1 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cidade: '',
            estado: '',
            endereco: '',
            bairro: '',
            file: null,
            message: null
        }
    }

    onChangeCep = (e) => {
        var config = {
            method: 'get',
            url: 'https://viacep.com.br/ws/'+e.target.value+'/json/',
            headers: { }
        };
            
        axios(config)
        .then((response) => {
            this.setState({ endereco: response.data.logradouro, cidade: response.data.localidade, estado: response.data.uf, bairro: response.data.bairro})
        })
    }

    beforeUpload = file => {
        const specialChars = /^[a-zA-Z0-9_-\d ]+$/
        const fileWithoutExtension = file.name.split('.').slice(0, -1).join()
        const acceptedFormats = ['jpeg', 'jpg', 'pdf', 'png']
        const fileSize = file.size
        if (specialChars.test(fileWithoutExtension) === false) {
            this.setState({ message: 'O nome do arquivo não pode conter caracteres especiais e acentos.' })
        } else if (acceptedFormats.includes(file.name.split('.')[1]) === false) {
            this.setState({ message: 'Por favor, envie arquivos nos formatos jpg, jpeg, pdf ou png.' })
        } else if (fileSize > 5242880) { // 5MB in bytes
            this.setState({ message: 'Por favor, envie arquivos de até 5MB.' })               
        } else {
                this.setState({file})
            }
        return false
    }

    onRemove = () => {
        this.setState({ file: null })
    }
    
    render() {
        const { isLoading, error, handleSubmit, userid } = this.props
        return(
            <Row>
                <FormEndereco beforeUpload={this.beforeUpload} onChangeCep={this.onChangeCep} cidade={this.state.cidade} estado={this.state.estado} endereco={this.state.endereco} bairro={this.state.bairro} message={this.state.message} handleSubmit={handleSubmit} error={error} isLoading={isLoading} userid={userid} file={this.state.file} />
            </Row>
            )
    }
}
export default Form2
